/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'QR-code-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M568.89 0v455.11h455.108V0H568.889zm398.22 398.222H625.775V56.89h341.333v341.333zm-853.332-56.89h227.556V113.778H113.778v227.556zM.001 1024h455.11v-455.11H.002v455.11zM56.89 625.778h341.333V967.11H56.89V625.778zm853.33-512H682.666v227.555h227.556V113.777zM.002 455.11h455.11V0H.002v455.11zM56.89 56.889h341.333v341.333H56.89V56.89zm853.33 967.11H1024V796.444H910.221v227.555zm0-341.334H1024V568.888H910.221v113.777zM113.779 910.221h227.556V682.665H113.778v227.556zm625.776-341.333H568.889v170.667h170.665v56.889h113.778V682.665H739.554V568.888zM568.889 1024h227.554V910.221H568.889v113.778z"/>'
  }
})
